<template>
  <market-map :options="options" :loading="loading" :error="error" />
</template>

<script>
import { groupStocksBySector } from "~/core/market-map";

import MarketMap from "~/components/market-map/index";
import { createMarketMapChart } from "~/components/market-map/chart/market-map-chart";

export default {
  data() {
    return {
      options: {
        title: {
          text: ""
        }
      },
      loading: false,
      error: false
    };
  },
  async mounted() {
    try {
      this.loading = true;

      const { data: stocks } = await this.$axios.$get("stocks", {
        params: { origin: "russian", mode: "full", limit: 500 }
      });

      const stocksBySectors = groupStocksBySector(stocks, { origin: "ru" });

      this.options = await createMarketMapChart({ data: stocksBySectors });
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  },
  components: {
    MarketMap
  }
};
</script>

